import { render, staticRenderFns } from "./FarmCreateLink.vue?vue&type=template&id=02bc2310&scoped=true"
import script from "./FarmCreateLink.vue?vue&type=script&lang=js"
export * from "./FarmCreateLink.vue?vue&type=script&lang=js"
import style0 from "./FarmCreateLink.vue?vue&type=style&index=0&id=02bc2310&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bc2310",
  null
  
)

export default component.exports